import React, { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Modal, Btn } from "@/components/erp/ui";

// Pilih 1–3 mesin sekaligus + konfirmasi sebelum jalan
export const MultiStart = ({ j, free, act, onSaved }) => {
  const [sel, setSel] = useState([]); const [ask, setAsk] = useState(false); const [busy, setBusy] = useState(false);
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : s.length >= 3 ? s : [...s, id]));
  const names = sel.map((id) => free.find((m) => m.id === id)?.name);
  const go = async () => {
    setBusy(true);
    try {
      for (const id of sel.slice(1)) await api.post(`/prod/jobs/${j.id}/parallel`, { prints: 1, machine_id: id });
      if (sel.length > 1) toast.info(`${sel.length - 1} mesin tambahan dibuat — siapkan material masing-masing`);
      setAsk(false); setSel([]);
      await act("start", j, free.find((m) => m.id === sel[0]));
      onSaved();
    } catch (e) { toast.error(e?.response?.data?.detail || "Gagal"); } finally { setBusy(false); }
  };
  return (
    <div className="mt-3" data-testid={`job-machines-${j.id}`}>
      <div className="text-[11px] text-slate-500 mb-1">Pilih mesin (bisa 2–3 sekaligus), lalu Jalankan:</div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2">
        {free.map((m) => {
          const on = sel.includes(m.id); const n = sel.indexOf(m.id) + 1;
          return (
            <button key={m.id} type="button" data-testid={`job-start-${j.id}-${m.id}`} onClick={() => toggle(m.id)}
              className={`relative py-3 rounded-xl text-sm font-bold transition-transform active:scale-95 ${on ? "bg-emerald-600 text-white ring-2 ring-emerald-300" : m.id === j.planned_machine_id ? "bg-slate-900 text-white ring-2 ring-emerald-400" : "bg-slate-900 text-white hover:bg-slate-700"}`}>
              {m.name}{on && <span className="absolute -top-1.5 -right-1.5 w-5 h-5 rounded-full bg-white text-emerald-700 text-[11px] grid place-items-center shadow">{n}</span>}
            </button>
          );
        })}
        {!free.length && <span className="text-xs text-rose-600 col-span-3">Semua mesin sedang dipakai / perbaikan</span>}
      </div>
      {sel.length > 0 && <Btn className="mt-2" data-testid={`job-run-${j.id}`} onClick={() => setAsk(true)}>Jalankan di {sel.length} mesin</Btn>}
      <Modal open={ask} onClose={() => setAsk(false)} title="Konfirmasi jalan mesin" footer={<><Btn variant="ghost" onClick={() => setAsk(false)}>Batal</Btn><Btn data-testid="job-run-confirm" disabled={busy} onClick={go}>Ya, jalankan</Btn></>}>
        <p className="text-sm mb-2">Jalankan <b>{j.file_name}</b> ({j.wo_code}) di:</p>
        <ul className="text-sm space-y-1 mb-3" data-testid="job-run-list">
          {names.map((n, i) => <li key={sel[i]}>• <b>{n}</b> {i === 0 ? "— mulai sekarang" : "— mesin tambahan, siapkan material dulu"}</li>)}
        </ul>
        {sel.length > 1 && <p className="text-xs text-amber-700 bg-amber-50 rounded-lg p-2">Bila target WO sudah terpenuhi, hasil berlebih dari mesin lain tetap dihitung <b>cacat</b> walau hasilnya bagus.</p>}
      </Modal>
    </div>
  );
};
